import { Link } from "../../molecules/Link";

export const GrupoSidebar = (props) => {
  return (
    <nav
      id="sidebar"
      className="flex flex-col min-w-[13rem] min-h-screen bg-theme-blue text-white"
    >
      <Link route={"/grupos"}>{"Lista de Grupos"} </Link>
      <Link route={"/grupos/activos"}>{"Grupos Activos"} </Link>
      <Link route={"/grupos/registrar"}>{"Agregar Grupos"} </Link>
      {/* <Link route={"/turnos"}>{"Turnos"} </Link>
      <Link route={"/modalidades"}>{"Modalidades"} </Link> */}
      <Link route={"/horarios"}>{"Horarios"} </Link>
      <Link route={"/grupos/UnirGrupos"}>{"Unir Grupos"} </Link>
      <Link route="/grupos/filtrar-fechas">Filtrar por Fechas</Link>
      <Link route="/grupos/filtrar-notas">Filtrar por Notas</Link>

    </nav>
  );
};
